import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { Link } from '@mui/material';

type Props = {
    path: string;
    children: string;
}

export const RouterLink = ({ path, children }: Props) => {
    const navigate = useNavigate();

    const handleClick = useCallback(() => {
        navigate(path);
    }, [path, navigate]);

    return (
        <Link href="#" onClick={handleClick}>
            {children}
        </Link>
    )
}
